import format from "date-fns/format";

import { Calendar } from "@livechat/design-system-icons";

import { CustomDateRangeFilterId, Filter, IDateRangeFilter } from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const labelsMap = {
  [CustomDateRangeFilterId.Today]: "Rated today",
  [CustomDateRangeFilterId.Yesterday]: "Rated yesterday",
  [CustomDateRangeFilterId.Last7Days]: "Rated in last 7 days",
  [CustomDateRangeFilterId.LastMonth]: "Rated last month",
};

export const ratingDateRangeFilterConfig: IFilterConfig = {
  title: "Rating date",
  multiple: false,
  icon: Calendar,
  getFilterLabelValues: (filterValues: IDateRangeFilter): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    const label =
      // @ts-expect-error TS(7053)
      labelsMap[filterValues.id] ||
      // @ts-expect-error TS(2345)
      `Rated: ${format(filterValues.from, "YYYY-MM-DD")} – ${format(filterValues.to, "YYYY-MM-DD")}`;

    return [
      {
        key: Filter.RatingDateRange,
        label,
      },
    ];
  },
};
